// Flex-wrap already keeps every row's thumbnails evenly stretched
// (assets/css/components/gallery.css), which avoids a small dangling
// thumbnail on its own. The one case flex-wrap can't solve by itself
// is a single item left alone on the last line -- this pulls the
// previous row's last item down to join it, and sizes both to split
// that row evenly, so there are always at least two.

export default function photoGrid() {
    const grid = document.querySelector(".photo-grid");
    if (!grid) {
        return;
    }

    const GAP = 2;

    function rowsOf(cards) {
        const rows = [];
        cards.forEach((card) => {
            const top = card.offsetTop;
            const row = rows.find((r) => Math.abs(r.top - top) < 1);
            if (row) {
                row.items.push(card);
            } else {
                rows.push({ top, items: [card] });
            }
        });
        return rows;
    }

    function balance() {
        const cards = Array.from(grid.children);
        cards.forEach((card) => {
            card.style.flexBasis = "";
        });

        if (cards.length < 3) {
            return;
        }

        const rows = rowsOf(cards);
        const lastRow = rows[rows.length - 1];

        if (rows.length < 2 || lastRow.items.length !== 1) {
            return;
        }

        const prevRow = rows[rows.length - 2];
        const promoted = prevRow.items[prevRow.items.length - 1];
        const orphan = lastRow.items[0];

        const pairWidth = (grid.clientWidth - GAP) / 2;
        promoted.style.flexBasis = `${pairWidth}px`;
        orphan.style.flexBasis = `${pairWidth}px`;
    }

    balance();

    let resizeTimer;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(balance, 150);
    });
}
